/* TR cart drawer: "You might also like" slider (dots + one-tap add) */
(function () {
  if (window.__trUp) return;
  window.__trUp = true;

  function step(track) {
    var c = track.children;
    if (c.length > 1) return c[1].offsetLeft - c[0].offsetLeft;
    return c[0] ? c[0].offsetWidth : 1;
  }
  function sync(track) {
    var i = Math.round(track.scrollLeft / step(track));
    var dots = track.parentNode.querySelectorAll('.tr-up__dot');
    for (var k = 0; k < dots.length; k++) dots[k].classList.toggle('is-on', k === i);
  }

  document.addEventListener('scroll', function (e) {
    var t = e.target;
    if (t && t.classList && t.classList.contains('tr-up__track')) sync(t);
  }, true);

  document.addEventListener('click', function (e) {
    var dot = e.target.closest && e.target.closest('.tr-up__dot');
    if (dot) {
      var track = dot.closest('.tr-up').querySelector('.tr-up__track');
      track.scrollTo({ left: Number(dot.dataset.i) * step(track), behavior: 'smooth' });
      return;
    }
    var btn = e.target.closest && e.target.closest('[data-tr-up-add]');
    if (!btn || btn.disabled) return;
    e.preventDefault();
    var drawer = document.querySelector('cart-drawer');
    var label = btn.textContent;
    btn.disabled = true;
    btn.textContent = '...';
    var body = { items: [{ id: Number(btn.dataset.variantId), quantity: 1 }] };
    if (drawer && drawer.getSectionsToRender) {
      body.sections = drawer.getSectionsToRender().map(function (s) { return s.id; });
      body.sections_url = window.location.pathname;
    }
    var url = ((window.routes && window.routes.cart_add_url) || '/cart/add') + '.js';
    fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { return r.json(); })
      .then(function (state) {
        if (state.status) throw new Error(state.description || 'error');
        if (drawer && drawer.renderContents) drawer.renderContents(state);
        else window.location.href = '/cart';
      })
      .catch(function () {
        btn.disabled = false;
        btn.textContent = 'Sold out';
        setTimeout(function () { btn.textContent = label; }, 1800);
      });
  });
})();
